/*---------------------------------

If a stripe connect customer already 
has a currency set IT CANNOT BE CHANGED
in order to SIMULATE a change we must
delete the customer form the connect
account and add a new. This modal
interfaces with the API to faciliate
this "simulation."

---------------------------------*/
import {useDispatch,useSelector} from 'react-redux'
import {selectShowResetCurrencyModal,setShowResetCurrencyModal,selectAllowCurrencyUpdate} from './slice'
import {envAwarePost} from '../../../util/util'
import Button from 'react-bootstrap/Button'
import Alert from 'react-bootstrap/Alert'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import useStripeAccount from '../../../hooks/useStripeAccount'
import { Elements, ElementsConsumer } from '@stripe/react-stripe-js'
import BillingUpdateForm from './BillingUpdateForm'

const ResetCurrencyModal = ()=>{
	const dispatch = useDispatch()
	const show = useSelector(selectShowResetCurrencyModal)
	const allowUpdate = useSelector(selectAllowCurrencyUpdate)
	const handleClose = ()=>{
		dispatch(setShowResetCurrencyModal(false))
	}
	
	const user = useSelector(state => state.users.current_user)
	const stripePromise = useStripeAccount(user?.trainer_stripe_account)
	return (
		<Modal show={show} onHide={handleClose}>
			<Modal.Header closeButton>
				<Modal.Title>
					Update Account Currency
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Alert variant="danger" className="text-dark">
					You are attempting to purchase a subscription using a currency that is different from the one you've previously used. 
					You must reset your billing in order continue. 
					<hr className="my-1"/>
					<strong className="d-block text-center">
						{
							allowUpdate?
							'After updating, retry your subscription':
							'You must cancel all active subscriptions to continue'
						}
					</strong>
				</Alert>
				{allowUpdate&&
					<>
						<Elements stripe={stripePromise}>
							<ElementsConsumer>
								{({ elements, stripe }) => (
									<BillingUpdateForm
										elements={elements}
										stripe={stripe}
										create_new_account={true}
									/>
								)}
							</ElementsConsumer>
						</Elements>
						<div className="text-center">
							
						</div>
					</>
				}
			</Modal.Body>
		</Modal>
	)
}

export default ResetCurrencyModal